import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {TableModule} from "primeng/table";
import {DatePipe} from "@angular/common";
import {MessageService} from "primeng/api";
import {FeedbackService} from "../../services/feedback.service";
import {FeedbackDto} from "admin-api-dto";

@Component({
  selector: 'app-feedback-tab',
  standalone: true,
  imports: [TableModule, DatePipe],
  templateUrl: './feedback-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackTabComponent {
  private readonly feedbackService = inject(FeedbackService);
  private readonly messageService = inject(MessageService);

  protected readonly items = signal<FeedbackDto[]>([]);
  protected readonly loading = signal(true);

  constructor() {
    this.feedbackService.getFeedback().subscribe({
      next: items => {
        this.items.set(items);
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.messageService.add({severity: 'error', summary: 'Failed to load feedback'});
      }
    });
  }
}
